import { useTranslation } from 'react-i18next';

import { CompaniesList } from '@/features/company';
import { usePageTitle } from '@/features/pageTitle';
import { PageContainer } from '@/shared/ui';

export const CompaniesPage = () => {
  const { t } = useTranslation();

  usePageTitle(t('common:menu.companies'));

  return (
    <PageContainer>
      <CompaniesList />
    </PageContainer>
  );
};
